﻿(function (angular, parseInt) {
  "use strict";

  var GAMMA = 1.8;

  angular.module("Toyota.Factories").factory("ColourService", function () {
    function hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      var fullformHex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullformHex);

      /* eslint-disable no-magic-numbers */
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
      /* eslint-enable no-magic-numbers */
    }

    // LINEAR to LOGARITHMIC
    function reGamma(rG) {
      return Math.pow(rG, 1 / GAMMA);
    }

    // LOGARITHMIC to LINEAR
    function deGamma(dG) {
      return Math.pow(dG, GAMMA);
    }

    // sRGB BT-709 BRIGHTNESS
    function brightness(b) {
      /* eslint-disable no-magic-numbers */
      var rlin = deGamma(hexToRgb(b).r / 255);
      var glin = deGamma(hexToRgb(b).g / 255);
      var blin = deGamma(hexToRgb(b).b / 255);
      return reGamma(0.2126 * rlin + 0.7152 * glin + 0.0722 * blin) * 100;
      /* eslint-enable no-magic-numbers */
    }

    // Compares contrast of a given color to the light/dark arguments and returns whichever is most "contrasty"
    function contrastColours(sourceColor, lightColor, darkColor) {
      var color = sourceColor ? sourceColor : "#000000";

      var light = lightColor ? lightColor : "#FFFFFF";
      var dark = darkColor ? darkColor : "#000000";

      var colourbrightness = deGamma(brightness(color));
      var lightTextBrightness = deGamma(brightness(light));
      var darkTextBrightness = deGamma(brightness(dark));

      var isSourceColourDark =
        Math.abs(colourbrightness - lightTextBrightness) > Math.abs(colourbrightness - darkTextBrightness);

      return isSourceColourDark;
    }

    return {
      hexToRgb: hexToRgb,
      reGamma: reGamma,
      deGamma: deGamma,
      contrastColours: contrastColours,
    };
  });
})(window.angular, window.parseInt);
